import { React,useEffect,useState } from "react";
import { useGetCountingSupervisorRoReportQuery } from "../../../services/reportsServices";

import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "Counting Supervisor id and name",
  "Mobile number",
  "Email Id",
  "Login Status",
  "Scanning Status",
];

const CountingSupervisorRoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "Counting Supervisor Report"
  const SheetName = "Counting Supervisor Report"
  const [tableData, setTabledata] = useState([]);
  const tableHeader = [];
  const columns = [
    {
      Header: "Counting Supervisor Id and Name",
      accessor: "col1",
    },
    {
      Header: "Mobile Number",
      accessor: "col2",
    },
    {
      Header: "Email Id",
      accessor: "col3",
    },
    {
      Header: "Login Status",
      accessor: "col4",
    },
    {
      Header: "Scanning Status",
      accessor: "col5",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const { data: GetCountingSupervisorRoReport } =
    useGetCountingSupervisorRoReportQuery();
  useEffect(()=>{
    if(GetCountingSupervisorRoReport?.payload!=null){
    var tableData = [];
    GetCountingSupervisorRoReport?.payload?.countingSupervisorList?.map(
      (item) => {
        tableData.push({
          "col1": `${item.userId } - ${ item.userName}`,
          "col2": item.userMobile,
          "col3": item.userEmail,
          "col4": item.loginStatus==="Y"?"Yes":"No",
          "col5": item.scanningStatus==="Y"?"Started":"Not Started",
        });
      }
    );
    setTabledata(tableData);
    setTotalNoOfRecords(GetCountingSupervisorRoReport?.payload?.countingSupervisorList?.length)
    }
  },[GetCountingSupervisorRoReport?.payload])
 
  return (
    <LeftMenu>
    <div className="container box shadow ">
      <RunnerUpHeaderNew title={reportName}
  state={ <span >State : {GetCountingSupervisorRoReport?.payload?.stateName}<span style={{marginLeft:"13px"}}></span> Constituency: {GetCountingSupervisorRoReport?.payload?.acPcNo}-
             { GetCountingSupervisorRoReport?.payload?.acPcName}-{ GetCountingSupervisorRoReport?.payload?.constType}</span>}
  onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData)} 
  onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)} 
  />
      <div className="row">
        <div className="col-md-12">
          <label className="label_text">
            {/* <b style={{color:"black"}}>State name:</b> {GetCountingSupervisorRoReport?.payload?.stateName}  */}
          </label>
          <label className="label_text ml-3">
          {/* <b style={{color:"black"}}>AC/PC No. and Name:</b> {GetCountingSupervisorRoReport?.payload?.acPcNo}-
             { GetCountingSupervisorRoReport?.payload?.acPcName} */}
          </label>
        </div>
        <div className="col-md-12">
       
        <Table
          placeholder="Search"
          globalsearch={true}
          emptyMessage="No Record Found"
          selectall={true}
          columns={columns}
          data={tableData?.length === 0 ? [] : tableData}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
        </div>
      </div>
    </div>
   </LeftMenu>
  );
};

export default CountingSupervisorRoReport;
